export const GET_ARTISTS = 'GET_ARTISTS';
export const GET_ARTISTS_SUCCESS = 'GET_ARTISTS_SUCCESS';
export const GET_ARTISTS_FAIL = 'GET_ARTISTS_FAIL';
export const CLEAR_ARTISTS = 'CLEAR_ARTIST_DATA';

